import { useEffect, useState } from "react";
import type { LookUpEnvelope } from "../../../edge/src/contracts";

interface State {
  status: "idle" | "loading" | "ready" | "error";
  envelope?: LookUpEnvelope;
  error?: string;
}

export function useLookUp(query: string | null, sessionId: string): State {
  const [state, setState] = useState<State>({ status: "idle" });
  useEffect(() => {
    if (!query) return;
    let cancelled = false;
    setState({ status: "loading" });
    const edgeBase = (import.meta.env.VITE_EDGE_URL as string | undefined) ?? "";
    const url = `${edgeBase}/lookup?q=${encodeURIComponent(query)}&sid=${encodeURIComponent(sessionId)}`;
    fetch(url, { headers: { Accept: "application/json" } })
      .then(async (r) => {
        if (!r.ok && r.status !== 504) throw new Error(`HTTP ${r.status}`);
        const envelope = (await r.json()) as LookUpEnvelope;
        if (cancelled) return;
        setState({ status: "ready", envelope });
      })
      .catch((err: Error) => {
        if (cancelled) return;
        setState({ status: "error", error: err.message });
      });
    return () => {
      cancelled = true;
    };
  }, [query, sessionId]);
  return state;
}
